import React, { useEffect, useRef, useState } from 'react';
import { GameInterface } from '../constants/GameInterface';
import GameHeader from '../GameHeader';
import GameRoomEightPlayers from './GameRoomEightPlayers';
import GameRoomSevenPlayers from './GameRoomSevenPlayers';
import GameRoomSixPlayers from './GameRoomSixPlayers';
import GameRoomFivePlayers from './GameRoomFivePlayers';
import GameRoomFourPlayers from './GameRoomFourPlayers';
import GameRoomThreePlayers from './GameRoomThreePlayers';
import GameRoomTwoPlayers from './GameRoomTwoPlayers';
import GameRoomOnePlayer from './GameRoomOnePlayer';
import RulesDialog from '../dialogs/RulesDialog';
import JudgeRulesDialog from '../dialogs/JudgeRulesDialog';
import RemovePlayerDialog from '../dialogs/RemovePlayerDialog';
import EndExitGameDialog from '../dialogs/EndExitGameDialog';
import EndExitGameNotificationDialog from '../dialogs/EndExitGameNotificationDialog';
import { Dialogs } from '../constants/Dialogs';
import { supabase } from '../supabase/supabase';
import { Popups } from '../constants/Popups';
import { Player } from '../classes/Player';
import { arrangePlayers } from '../utils/ArrangePlayers';
import { getPronoun } from '../utils/PronounsUtil';
import { PronounForm } from '../constants/PronounForms';
import { Game } from '../classes/Game';
import { END_EXIT_GAME_NOTIFICATION_DIALOG_DURATION_IN_SECONDS, HAND_LENGTH, MAX_SCORE, MIN_NUM_OF_PLAYERS, ROUND_TIMER_TIME_IN_SECONDS, ROUND_WINNER_PAGE_DURATION_IN_SECONDS, SHOULD_SHOW_HAND_DURATION_IN_SECONDS, SHOULD_SHOW_SKIP_CARD_DURATION_IN_SECONDS, WAIT_DURATION_TO_DRAW_BLACK_CARDS_IN_SECONDS, WAIT_DURATION_TO_OPEN_RED_CARD_IN_SECONDS, WAIT_DURATION_TO_PLAY_IN_SECONDS } from '../constants/Constants';
import { RoundBlackCard } from '../classes/RoundBlackCards';
import { KeyMoment } from '../classes/KeyMoment';
import { Hand } from '../classes/Hand';
import { Round } from '../classes/Round';
import { RoundPhase } from '../constants/RoundPhase';
import { Stats } from '../classes/Stats';
import { convertStatusToRoundPhase } from '../utils/RoundPhaseUtils';
import { getPlayedRoundBlackCardsCount, shuffleRoundBlackCards } from '../utils/RoundBlackCardsUtils';
import { Score } from '../classes/Score';
import { Background } from '../classes/Background';
import { getBlackCardIndex, getRedCardIndex } from '../utils/CardsUtils';
import LoadingComponent from '../commonComponents/LoadingComponent';
import { getTimerText } from '../utils/TextsUtils';
import OpenRedCardDialog from '../game/OpenRedCardDialog';
import PlayBlackCardsDialog from '../game/PlayBlackCardsDialog';
import SelectBlackCardDialog from '../selectBlackCard/SelectBlackCardDialog';
import RoundWinnerDialog from '../game/RoundWinnerDialog';
import { getLeadingPlayerScore } from '../utils/ScoresUtils';
import { Genders } from '../constants/Genders';
import WaitingForHostDialog from '../dialogs/WaitingForHostDialog';
import HeaderInGame from '../HeaderInGame';
import { PageView } from '../classes/PageView';
import { Pages } from '../constants/Pages';

function GameRoomDialog({dialog, setDialog, isHost, setIsHost, gameId, setGameId, playerId, setPlayerId, isLate, setIsLate, statsId, setStatsId, keyMoments, setKeyMoments, players, setPlayers, scoresMap, setScoresMap}: GameInterface) {
    const deck = require("../images/deck.png");
    const defaultPlayer = new Player(0, "", 0, Genders.none, 0, "", "", new Hand("", 0, "", [], 0));
    const defaultRound = new Round(0, "", 0, 0, -1, 0, -1, 0, 0);
    const roundTimerRef = useRef<any>(null);
    const roundWinnerPageTimerRef = useRef<any>(null);

    const [roundBlackCards, setRoundBlackCards] = useState<RoundBlackCard[]>([]);
    const [lastOpenRoundBlackCardIdx, setLastOpenRoundBlackCardIdx] = useState(-1);
    const [usedBlackCardsIndices, setUsedBlackCardsIndices] = useState<number[]>([]);
    const [currentPlayer, setCurrentPlayer] = useState<Player>(defaultPlayer);
    const [currentRound, setCurrentRound] = useState<Round>(defaultRound);
    const [criminal, setCriminal] = useState<Player>(defaultPlayer);
    const [judge, setJudge] = useState<Player>(defaultPlayer);
    const [roundPhase, setRoundPhase] = useState<RoundPhase>(RoundPhase.initialPhase);
    const [popup, setPopup] = useState(Popups.none);
    const [winningBlackCardIdx, setWinningBlackCardIdx] = useState(-1);
    const [roundWinner, setRoundWinner] = useState<Player>(defaultPlayer);
    const [skipped, setSkipped] = useState(false);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [shouldShowHand, setShouldShowHand] = useState(false);
    const [hostIsInBackground, setHostIsInBackground] = useState(false);
    const [isDeletingGame, setIsDeletingGame] = useState(false);
    const [endExitGameNotificationTitle, setEndExitGameNotificationTitle] = useState("");
    const [endExitGameNotificationSubtitle, setEndExitGameNotificationSubtitle] = useState("");
    
    const playersRef = useRef<Player[]>([]);
    const roundBlackCardsRef = useRef<RoundBlackCard[]>([]);
    const lastOpenRoundBlackCardIdxRef = useRef(-1);
    const keyMomentsRef = useRef<KeyMoment[]>([]);
    const scoresMapRef = useRef<Map<number, number>>(new Map<number, number>());
    const currentPlayerRef = useRef<Player>(defaultPlayer);
    const criminalRef = useRef<Player>(defaultPlayer);
    const judgeRef = useRef<Player>(defaultPlayer);
    const roundWinnerRef = useRef<Player>(defaultPlayer);
    const currentRoundRef = useRef<Round>(defaultRound);
    const hostIsInBackgroundRef = useRef(false);
    const usedBlackCardsIndicesRef = useRef<number[]>([]);
    const roundPhaseRef = useRef<RoundPhase>(RoundPhase.initialPhase);
    const roundTimeInSecondsRef = useRef(ROUND_TIMER_TIME_IN_SECONDS);
    const roundWinnerPageTimeLeftInSecondsRef = useRef(ROUND_WINNER_PAGE_DURATION_IN_SECONDS);
    const winningBlackCardIdxRef = useRef(-1);

    const startNewRound = async (judgeExited: boolean) =>{
        await RoundBlackCard.updateRoundBlackCardIdx(gameId, -1);
        
        setPopup(Popups.none);
        roundTimeInSecondsRef.current = ROUND_TIMER_TIME_IN_SECONDS;
        roundWinnerPageTimeLeftInSecondsRef.current = ROUND_WINNER_PAGE_DURATION_IN_SECONDS;
        roundBlackCardsRef.current = [];
        setRoundBlackCards([]);
        lastOpenRoundBlackCardIdxRef.current = -1;
        setLastOpenRoundBlackCardIdx(-1);
        const newRoundId = judgeExited ? currentRoundRef.current.roundId : currentRoundRef.current.roundId + 1;
        const newRound: Round = {...defaultRound, roundId: newRoundId, game: gameId};
        currentRoundRef.current = {...newRound};
        setCurrentRound(newRound);
        roundPhaseRef.current = RoundPhase.initialPhase;
        setRoundPhase(RoundPhase.initialPhase);
        winningBlackCardIdxRef.current = -1;
        setWinningBlackCardIdx(-1);
        roundWinnerRef.current = defaultPlayer.clone();
        setRoundWinner(defaultPlayer);

        if (isHost) {
            drawBlackCards();
            play();
        } else if (hostIsInBackgroundRef.current) {
            await Round.updateRound(currentRoundRef.current.roundId, gameId, 0, 0, -1, RoundPhase.initialPhase);
            setTimeout(async () => {
                setPopup(Popups.waitingForHost);
            }, 2000)
        }
    }

    const getPlayers = async () => {
        setPlayers([]);
        let tempPlayers = await Player.getActivePlayers(gameId);
        tempPlayers = arrangePlayers(tempPlayers, playerId);
        const tempPlayers2 = [];
        for (let idx = 0; idx < tempPlayers.length; idx++) {
            if (tempPlayers[idx].id === playerId) {
                currentPlayerRef.current = tempPlayers[idx].clone();
                setCurrentPlayer(tempPlayers[idx])
            }
            tempPlayers2.push(tempPlayers[idx]);
        }
        setPlayers([...tempPlayers2]);
        return tempPlayers2;
    }

    const handlePlayersTableChanges = async (payload: any) => {
        const playerChangeJson = payload.new;
        const player = Player.fromJson(playerChangeJson);
        const idx = playersRef.current.findIndex((p) => p.id === player.id);
        const idx1 = roundBlackCardsRef.current.findIndex((c) => c.player === player.id);
        if (idx !== -1 && !player.isActive()) {
            // player exited the game
            const tempPlayers = [...playersRef.current];
            tempPlayers.splice(idx, 1);
            setPlayers([...tempPlayers]);

            if (idx1 !== -1) {
                const tempRoundBlackCards = [...roundBlackCardsRef.current];
                tempRoundBlackCards.splice(idx1, 1);
                roundBlackCardsRef.current = [...tempRoundBlackCards];
                setRoundBlackCards([...tempRoundBlackCards]);
            }

            if (scoresMapRef.current.get(player.id) !== undefined) {
                const tempScoresMap = new Map(scoresMapRef.current);
                tempScoresMap.delete(player.id);
                setScoresMap(new Map(tempScoresMap));
            }

            if (player.id === currentPlayerRef.current.id) {
                setDialog(Dialogs.survey);
            } else {
                const title = player.status === 2 ? player.name + " left the game" : player.name + " is kicked out";
                const subtitle = player.status === 2 ? "Guess " + getPronoun(player.gender, PronounForm.they) + " couldn't take the heat" : "#awkward";
                setEndExitGameNotificationTitle(title);
                setEndExitGameNotificationSubtitle(subtitle);
                setPopup(Popups.endExitGameNotification);
                setTimeout(async () => {
                    if (tempPlayers.length < MIN_NUM_OF_PLAYERS) {
                        // all remaining players (not just the host) end the game, in case host is not active
                        await Game.updateGameStatus(gameId, 3);
                        Stats.updateEndEarlyStats(statsId);
                    } else {
                        await startNewRound(currentRoundRef.current.judge === player.id);
                    }
                }, END_EXIT_GAME_NOTIFICATION_DIALOG_DURATION_IN_SECONDS * 1000)
            }
        }
    }

    const handleGamesTableChanges = async (payload: any) => {
        const gameChangeJson = payload.new;
        const game = Game.fromJson(gameChangeJson);
        if (game.status === 2) {
            // game has ended by the host
            if (isHost) {
                setIsDeletingGame(true);
                await Game.deleteGame(gameId);
                setDialog(Dialogs.survey);
            } else {
                setEndExitGameNotificationTitle("Game Ended");
                setEndExitGameNotificationSubtitle("The host ended the game. See you next time!");
                setPopup(Popups.endExitGameNotification);
                setTimeout(async () => {
                    setDialog(Dialogs.survey);
                }, END_EXIT_GAME_NOTIFICATION_DIALOG_DURATION_IN_SECONDS * 1000)
            }
        } else if (game.status === 3) {
            // game has ended for not having enough players
            setEndExitGameNotificationTitle("Game Ended");
            setEndExitGameNotificationSubtitle("The game requires at least " + MIN_NUM_OF_PLAYERS + " players. See you next time!");
            setPopup(Popups.endExitGameNotification);
            await Game.deleteGame(gameId);
            setTimeout(async () => {
                setDialog(Dialogs.survey);
            }, END_EXIT_GAME_NOTIFICATION_DIALOG_DURATION_IN_SECONDS * 1000)
        }
    }

    const handleHandsTableChanges = async (payload: any) => {
        const handChangeJson = payload.new;
        const hand = Hand.fromJson(handChangeJson);
        for (let idx = 0; idx < playersRef.current.length; idx++) {
            if (hand.player === playersRef.current[idx].id) {
                const tempPlayers = [...playersRef.current];
                tempPlayers[idx].hand = hand;
                setPlayers([...tempPlayers]);
                break;
            }
        }
    }

    const handlePlayerHandsTableChanges = async (payload: any) => {
        const handChangeJson = payload.new;
        const hand = Hand.fromJson(handChangeJson);
        const tempCurrentPlayer = currentPlayerRef.current.clone();
        tempCurrentPlayer.hand = hand;
        currentPlayerRef.current = tempCurrentPlayer.clone();
        setCurrentPlayer(tempCurrentPlayer);
        setShouldShowHand(true);
        setTimeout(async () => {
            setShouldShowHand(false);
        }, SHOULD_SHOW_HAND_DURATION_IN_SECONDS * 1000)
    }

    const handleRoundsTableChanges = async (payload: any) => {
        const roundChangeJson = payload.new;
        const round = Round.fromJson(roundChangeJson);
        clearInterval(roundTimerRef.current);
        roundTimerRef.current = null;
        clearInterval(roundWinnerPageTimerRef.current);
        roundWinnerPageTimerRef.current = null;
        setPopup(Popups.none);
        for (let idx = 0; idx < playersRef.current.length; idx++) {
            if (playersRef.current[idx].id === round.criminal) {
                criminalRef.current = playersRef.current[idx].clone();
                setCriminal(playersRef.current[idx]);
            }
            if (playersRef.current[idx].id === round.judge) {
                judgeRef.current = playersRef.current[idx].clone();
                setJudge(playersRef.current[idx]);
            }
        }
  
        let tempRoundPhase = convertStatusToRoundPhase(round.status);
        if (tempRoundPhase === RoundPhase.openRedCard) {
            if (round.roundId === currentRoundRef.current.roundId && round.judge === currentRoundRef.current.judge && round.criminal === currentRoundRef.current.criminal && round.status === currentRoundRef.current.status) {
                // the red card was skipped
                setSkipped(true);
                setTimeout(async () => {
                    setSkipped(false);
                    currentRoundRef.current = {...round};
                    setCurrentRound(round);
                }, SHOULD_SHOW_SKIP_CARD_DURATION_IN_SECONDS * 1000)
            } else {
                currentRoundRef.current = {...round};
                setCurrentRound(round);
                setTimeout(async () => {
                    roundPhaseRef.current = tempRoundPhase;
                    setRoundPhase(tempRoundPhase);
                }, WAIT_DURATION_TO_OPEN_RED_CARD_IN_SECONDS * 1000)
            }
        } else {
            currentRoundRef.current = {...round};
            setCurrentRound(round);
            if (tempRoundPhase === RoundPhase.playBlackCard && round.judge === playerId) {
                tempRoundPhase = RoundPhase.waitForOthersToPlay;
                roundPhaseRef.current = tempRoundPhase;
                setRoundPhase(tempRoundPhase);
                setPopup(Popups.judgeRules);
            } else {
                roundPhaseRef.current = tempRoundPhase;
                setRoundPhase(tempRoundPhase);
            }
  
            if (tempRoundPhase === RoundPhase.playBlackCard || tempRoundPhase === RoundPhase.waitForOthersToPlay) {
                startRoundTimer(0);
            }
  
            if (tempRoundPhase === RoundPhase.roundWinner) {
                startRoundWinnerPageTimer(0);
                winningBlackCardIdxRef.current = round.winningBlackCardIdx;
                setWinningBlackCardIdx(round.winningBlackCardIdx)
  
                const winnerIdx = playersRef.current.findIndex((p) => p.id === round.winner);
                if (winnerIdx !== -1) {
                    roundWinnerRef.current = playersRef.current[winnerIdx].clone();
                    setRoundWinner(playersRef.current[winnerIdx]);
                    const idx = roundBlackCardsRef.current.findIndex((c) => c.player === playersRef.current[winnerIdx].id);
                    if (idx !== -1) {
                        const keyMoment = new KeyMoment(gameId, round.redCardIdx, round.winningBlackCardIdx, criminalRef.current.name, criminalRef.current.gender, criminalRef.current.image, roundWinnerRef.current.name);
                        const tempKeyMoments = [...keyMomentsRef.current];
                        tempKeyMoments.push(keyMoment);
                        setKeyMoments([...tempKeyMoments]);
                    }
                }

                setTimeout(async () => {
                    if (getLeadingPlayerScore(scoresMapRef.current) >= MAX_SCORE) {
                        // we have a winner
                        await Game.deleteGame(gameId);
                        Stats.updateEndTime(statsId);
                        setDialog(Dialogs.winner);
                    } else {
                        await startNewRound(false);
                    }
                }, ROUND_WINNER_PAGE_DURATION_IN_SECONDS * 1000)
            }
        }
    }

    const handleRoundBlackCardsTableChanges = async (payload: any) => {
        const roundBlackCardChangeJson = payload.new;
        const roundBlackCard = RoundBlackCard.fromJson(roundBlackCardChangeJson);
        if (roundBlackCard.blackCardIdx === -1) {
            // this means that the round is over and we are setting the round black card idx back to -1
            return;
        }
        const idx = roundBlackCardsRef.current.findIndex((c) => c.player === roundBlackCard.player);
        if (idx === -1) {
            // this means that a player played a black card
            let tempRoundBlackCards = [...roundBlackCardsRef.current];
            tempRoundBlackCards.push(roundBlackCard);
            tempRoundBlackCards = shuffleRoundBlackCards(tempRoundBlackCards);
            roundBlackCardsRef.current = [...tempRoundBlackCards];
            setRoundBlackCards([...tempRoundBlackCards]);
            if (roundBlackCard.player === playerId) {
                roundPhaseRef.current = RoundPhase.waitForOthersToPlay;
                setRoundPhase(RoundPhase.waitForOthersToPlay);
            }

            const playedRoundBlackCardCount = getPlayedRoundBlackCardsCount(tempRoundBlackCards);
            if (playedRoundBlackCardCount === playersRef.current.length - 1) {
                // if every player (except the judge) played, move to the next phase
                if (isHost) {
                    await Round.updateRoundStatus(gameId, RoundPhase.lookAtPlayedCards);
                } else if (hostIsInBackgroundRef.current) {
                    setPopup(Popups.waitingForHost);
                    clearInterval(roundTimerRef.current);
                    roundTimerRef.current = null;
                }
            }
        } else {
            // this means that the judge opened a black card
            const tempRoundBlackCards = [...roundBlackCardsRef.current];
            tempRoundBlackCards[idx] = roundBlackCard;
            roundBlackCardsRef.current = [...tempRoundBlackCards];
            setRoundBlackCards([...tempRoundBlackCards]);
            lastOpenRoundBlackCardIdxRef.current = idx;
            setLastOpenRoundBlackCardIdx(idx);
        }
    }

    const handleScoresTableChanges = async (payload: any) => {
        const scoreChangeJson = payload.new;
        const score = Score.fromJson(scoreChangeJson);
        const tempScoresMap = new Map(scoresMapRef.current);
        tempScoresMap.set(score.player, score.score);
        setScoresMap(new Map(tempScoresMap));
    }

    const handleBackgroundsTableChanges = async (payload: any) => {
        const backgroundChangeJson = payload.new;
        const background = Background.fromJson(backgroundChangeJson);
        hostIsInBackgroundRef.current = background.hostIsInBackground;
        setHostIsInBackground(background.hostIsInBackground);
    }

    const drawBlackCards = () => {
        setTimeout(async () => {
            for (let idx = 0; idx < playersRef.current.length; idx++) {
                let indicesStr = playersRef.current[idx].hand.indicesStr;
                for (let idx1 = playersRef.current[idx].hand.indices.length; idx1 < HAND_LENGTH; idx1++) {
                    const tempUsedBlackCardsIndices = [...usedBlackCardsIndicesRef.current];
                    let blackCardIndex = getBlackCardIndex(tempUsedBlackCardsIndices);
                    tempUsedBlackCardsIndices.push(blackCardIndex);
                    usedBlackCardsIndicesRef.current = [...tempUsedBlackCardsIndices];
                    setUsedBlackCardsIndices([...tempUsedBlackCardsIndices]);
                    indicesStr += String(blackCardIndex) + ",";
                }
                await Hand.updateHand(playersRef.current[idx].id, indicesStr);
            }
        }, WAIT_DURATION_TO_DRAW_BLACK_CARDS_IN_SECONDS * 1000)
    }

    const getJudgeIdx = () => {
        return currentRoundRef.current.roundId % playersRef.current.length;
    }

    const getRandomCriminalIdx = (judgeIdx: number) => {
        const criminalIdx = Math.floor(Math.random() * playersRef.current.length);
        return criminalIdx !== judgeIdx ? criminalIdx : (judgeIdx + 1) % playersRef.current.length;
    }

    const howManyTimesCriminal = (playerIdx: number) => {
        const playerName = playersRef.current[playerIdx].name;
        let count = 0;
        for (let idx = 0; idx < keyMomentsRef.current.length; idx++) {
            if (keyMomentsRef.current[idx].criminalName === playerName) {
                count++;
            }
        }
        return count;
    }

    // Logic is to see which player has been criminal the least amount of time, and select that player
    const getCriminalIdx = (judgeIdx: number) => {
        if (keyMomentsRef.current.length === 0) {
            return getRandomCriminalIdx(judgeIdx);
        }
        const lowestCriminalIdxArr = [];
        const criminalCountMap = new Map<number, number>();
        // loop through players and find out how many times each player has been criminal
        for (let idx = 0; idx < playersRef.current.length; idx++) {
            if (idx !== judgeIdx) {
                const count = howManyTimesCriminal(idx);
                criminalCountMap.set(idx, count);
            }            
        }

        const criminalCountArrKeys = Array.from(criminalCountMap.keys());
        const criminalCountArrValues = Array.from(criminalCountMap.values());
        const minCount = Math.min.apply(null, criminalCountArrValues);
        for (let idx = 0; idx < criminalCountArrValues.length; idx++) {
            if (criminalCountArrValues[idx] === minCount) {
                lowestCriminalIdxArr.push(criminalCountArrKeys[idx]);
            }
        }

        if (lowestCriminalIdxArr.length === 0) {
            return getRandomCriminalIdx(judgeIdx);
        }

        const idx = Math.floor(Math.random() * lowestCriminalIdxArr.length);
        return lowestCriminalIdxArr[idx];
    }

    const startRoundTimer = (elapsedTimeInSeconds: number) => {
        const remainingTimeInSeconds = ROUND_TIMER_TIME_IN_SECONDS - elapsedTimeInSeconds;
        if (remainingTimeInSeconds < 0) {
            roundTimeInSecondsRef.current = 0;
            clearInterval(roundTimerRef.current);
            roundTimerRef.current = null;
        } else {
            roundTimeInSecondsRef.current = remainingTimeInSeconds;
        }

        roundTimerRef.current = setInterval(async () => {
            if (roundPhaseRef.current !== RoundPhase.playBlackCard && roundPhaseRef.current !== RoundPhase.waitForOthersToPlay) {
                clearInterval(roundTimerRef.current);
                roundTimerRef.current = null;
            }
            if (roundTimeInSecondsRef.current <= 0) {
                clearInterval(roundTimerRef.current);
                roundTimerRef.current = null;
                let count = 0;
                for (let idx = 0; idx < roundBlackCardsRef.current.length; idx++) {
                    if (roundBlackCardsRef.current[idx].blackCardIdx > -1) {
                        count++;
                    }
                }
                if (count > 0) {
                    // if at least one player played, move to the next phase
                    if (isHost) {
                        await Round.updateRoundStatus(gameId, RoundPhase.lookAtPlayedCards);
                    } else if (hostIsInBackgroundRef.current) {
                        setPopup(Popups.waitingForHost);
                    }
                } else {
                    await startNewRound(false);
                }
            }
            if (roundTimeInSecondsRef.current > 0)
            {
                roundTimeInSecondsRef.current = roundTimeInSecondsRef.current - 1;
            }
        }, 1000)
    }

    const startRoundWinnerPageTimer = (elapsedTimeInSeconds: number) => {
        const remainingTimeInSeconds = ROUND_WINNER_PAGE_DURATION_IN_SECONDS - elapsedTimeInSeconds;
        if (remainingTimeInSeconds < 0) {
            roundWinnerPageTimeLeftInSecondsRef.current = 0;
            clearInterval(roundWinnerPageTimerRef.current);
            roundWinnerPageTimerRef.current = null;
        } else {
            roundWinnerPageTimeLeftInSecondsRef.current = remainingTimeInSeconds;
        }

        roundWinnerPageTimerRef.current = setInterval(() => {
            if (roundWinnerPageTimeLeftInSecondsRef.current <= 0) {
                clearInterval(roundWinnerPageTimerRef.current);
                roundWinnerPageTimerRef.current = null;
            }
            if (roundWinnerPageTimeLeftInSecondsRef.current > 0) {
                roundWinnerPageTimeLeftInSecondsRef.current = roundWinnerPageTimeLeftInSecondsRef.current - 1;
            }
        }, 1000)
    }

    const handleCloseOpenedBlackCard = () => {
        lastOpenRoundBlackCardIdxRef.current = -1;
        setLastOpenRoundBlackCardIdx(-1);
    }

    const openEndExitGameDialog = () => {
        setPopup(Popups.endExitGame);
    }

    const openRulesDialog = () => {
        Stats.updateRulesClickCount(statsId);
        setPopup(Popups.rules);
    }

    const handleRefresh = async () =>
    {
        if (!isRefreshing) {
            setIsRefreshing(true);
            clearInterval(roundTimerRef.current);
            roundTimerRef.current = null;
            clearInterval(roundWinnerPageTimerRef.current);
            roundWinnerPageTimerRef.current = null;
            await refresh();
            setIsRefreshing(false);
        }
    }

    const openRemovePlayerDialog = () => {
        setPopup(Popups.removePlayer);
    }

    const closeDialog = () => {
        setPopup(Popups.none);
    }

    const  handleRemovePlayer = async (idx: number) => {
        if (idx < playersRef.current.length) {
            await Player.updatePlayerStatus(playersRef.current[idx].id, 3);
            Stats.updateDropoffCount(statsId);
            setPopup(Popups.none);
        }
    }

    const getBlackCardSubmitTime = () => {
        return ROUND_TIMER_TIME_IN_SECONDS - roundTimeInSecondsRef.current;
    }

    const play = () => {
        setTimeout(async () => {
            const judgeIdx = getJudgeIdx();
            const criminalIdx = getCriminalIdx(judgeIdx);
            const redCardIdx = await getRedCardIndex(gameId);
            if (judgeIdx < playersRef.current.length && criminalIdx < playersRef.current.length) {
                await Round.updateRound(currentRoundRef.current.roundId, gameId, playersRef.current[judgeIdx].id, playersRef.current[criminalIdx].id, redCardIdx, RoundPhase.openRedCard);
            }
        }, WAIT_DURATION_TO_PLAY_IN_SECONDS * 1000)
    }

    const refresh = async () => {
        const games = await Game.getGames(gameId);
        if (games.length === 0 || games[0].status === 2 || games[0].status === 3) {
            // Game ended - go home
            setDialog(Dialogs.survey);
        } else {
            const refreshPlayers = await getPlayers();
            const idx = refreshPlayers.findIndex((p) => p.id === playerId);
            if (idx === -1) {
                // the player was removed from the game - go home
                setDialog(Dialogs.survey);
            } else {
                roundBlackCardsRef.current = [];
                setRoundBlackCards([]);
                scoresMapRef.current = new Map<number, number>();
                setScoresMap(new Map<number, number>());
                
                let tempHands: Hand[] = [];
                const tempHand = await Hand.getHand(playerId);
                const round = await Round.getRound(gameId);
                const tempRoundBlackCards = await RoundBlackCard.getRoundBlackCards(gameId);
                const tempScores = await Score.getScores(gameId);
                const tempScores2 = new Map(scoresMap);

                if (isHost) {
                    tempHands = await Hand.getHands(gameId);
                }

                let tempRoundPhase = convertStatusToRoundPhase(round.status);

                const currentTime = Date.now();
                const elapsedTimeInSeconds = Math.floor((currentTime - round.lastUpdateTime) / 1000);
                setPopup(Popups.none);
                for (let idx = 0; idx < refreshPlayers.length; idx++) {
                    if (refreshPlayers[idx].id === round.judge) {
                        judgeRef.current = refreshPlayers[idx].clone();
                        setJudge(refreshPlayers[idx]);
                    }
                    if (refreshPlayers[idx].id === round.criminal) {
                        criminalRef.current = refreshPlayers[idx].clone();
                        setCriminal(refreshPlayers[idx]);
                    }
                    const idx1 = tempRoundBlackCards.findIndex((c) => c.player === refreshPlayers[idx].id);
                    if (idx1 !== -1) {
                        const tempRoundBlackCards2 = [...roundBlackCardsRef.current];
                        tempRoundBlackCards2.push(tempRoundBlackCards[idx1]);
                        roundBlackCardsRef.current = [...tempRoundBlackCards2];
                        setRoundBlackCards([...tempRoundBlackCards2]);
                    }

                    const idx2 = tempScores.findIndex((s) => s.player === refreshPlayers[idx].id);
                    if (idx2 !== -1) {
                        tempScores2.set(refreshPlayers[idx].id, tempScores[idx2].score);
                        setScoresMap(new Map(tempScores2));
                    }

                    if (isHost) {
                        const idx3 = tempHands.findIndex((h) => h.player === refreshPlayers[idx].id);
                        if (idx3 !== -1) {
                            const tempPlayers = [...refreshPlayers];
                            tempPlayers[idx].hand = tempHands[idx3];
                            setPlayers([...tempPlayers]);
                        }
                    }

                    if (refreshPlayers[idx].id === round.winner) {
                        roundWinnerRef.current = refreshPlayers[idx].clone();
                        setRoundWinner(refreshPlayers[idx]);
                    }
                }
                let tempRoundBlackCards2 = [...roundBlackCardsRef.current];
                tempRoundBlackCards2 = shuffleRoundBlackCards(tempRoundBlackCards2);
                roundBlackCardsRef.current = [...tempRoundBlackCards2];
                setRoundBlackCards([...tempRoundBlackCards2]);

                const tempCurrentPlayer = currentPlayerRef.current.clone();
                tempCurrentPlayer.hand = tempHand;
                currentPlayerRef.current = tempCurrentPlayer.clone();
                setCurrentPlayer(tempCurrentPlayer);

                currentRoundRef.current = {...round};
                setCurrentRound(round);
                if (tempRoundPhase === RoundPhase.playBlackCard && judgeRef.current.id === playerId) {
                    tempRoundPhase = RoundPhase.waitForOthersToPlay;
                    roundPhaseRef.current = tempRoundPhase;
                    setRoundPhase(tempRoundPhase);
                } else if (tempRoundPhase === RoundPhase.playBlackCard && tempHand.indices.length < HAND_LENGTH) {
                    tempRoundPhase = RoundPhase.waitForOthersToPlay;
                    roundPhaseRef.current = tempRoundPhase;
                    setRoundPhase(tempRoundPhase);
                } else {
                    roundPhaseRef.current = tempRoundPhase;
                    setRoundPhase(tempRoundPhase);
                }

                lastOpenRoundBlackCardIdxRef.current = -1;
                setLastOpenRoundBlackCardIdx(-1);
                winningBlackCardIdxRef.current = round.winningBlackCardIdx;
                setWinningBlackCardIdx(round.winningBlackCardIdx);

                if (tempRoundPhase === RoundPhase.initialPhase) {
                    await startNewRound(false);
                    return;
                }
                if (tempRoundPhase === RoundPhase.playBlackCard || tempRoundPhase === RoundPhase.waitForOthersToPlay) {
                    const playedRoundBlackCardCount = getPlayedRoundBlackCardsCount(tempRoundBlackCards2);
                    if (isHost && (elapsedTimeInSeconds >= ROUND_TIMER_TIME_IN_SECONDS || playedRoundBlackCardCount === refreshPlayers.length - 1)) {
                        // host comes back, and it's time to move to the next phase
                        await Round.updateRoundStatus(gameId, RoundPhase.lookAtPlayedCards);
                    } else {
                        startRoundTimer(elapsedTimeInSeconds);
                    }
                    return;
                }
                if (tempRoundPhase === RoundPhase.roundWinner) {
                    startRoundWinnerPageTimer(elapsedTimeInSeconds);
                    setTimeout(async () => {
                        if (getLeadingPlayerScore(tempScores2) >= MAX_SCORE) {
                            // we have a winner
                            setDialog(Dialogs.winner);
                        } else {
                            await startNewRound(false);
                        }
                    }, (ROUND_WINNER_PAGE_DURATION_IN_SECONDS - elapsedTimeInSeconds) * 1000)
                }
            }
        }
    }

    const handleVisibilityChange = async () => {
        if (document.hidden) {
            roundPhaseRef.current = RoundPhase.initialPhase;
            setRoundPhase(RoundPhase.initialPhase);
            if (isHost) {
                await Background.updateHostIsInBackground(gameId, true);
            }
            clearInterval(roundTimerRef.current);
            roundTimerRef.current = null;
            clearInterval(roundWinnerPageTimerRef.current);
            roundWinnerPageTimerRef.current = null;
            supabase.removeAllChannels();
        } else {
            subscribeGamesChannel();
            subscribePlayersChannel();
            subscribeHandChannel();
            subscribeRoundsChannel();
            subscribeRoundBlackCardsChannel();
            subscribeScoresChannel();

            if (isHost) {
                subscribeHandsChannel();
                await Background.updateHostIsInBackground(gameId, false);
            } else {
                subscribeBackgroundsChannel();
            }

            refresh();
        }
    }

    const subscribeGamesChannel = () => {
        supabase
        .channel('gamesGameRoomChannel')
        .on('postgres_changes', { event: '*', schema: 'public', table: 'Games', filter: `id=eq.${gameId}`, }, handleGamesTableChanges)
        .subscribe();
    }

    const subscribePlayersChannel = () => {
        supabase
            .channel('playersGameRoomChannel')
            .on('postgres_changes', { event: '*', schema: 'public', table: 'Players', filter: `game=eq.${gameId}`, }, handlePlayersTableChanges)
            .subscribe();
    }

    const subscribeHandsChannel = () => {
        supabase
            .channel('handsChannel')
            .on('postgres_changes', { event: '*', schema: 'public', table: 'Hands', filter: `game=eq.${gameId}`, }, handleHandsTableChanges)
            .subscribe();
    }

    const subscribeHandChannel = () => {
        supabase
            .channel('handChannel')
            .on('postgres_changes', { event: '*', schema: 'public', table: 'Hands', filter: `player=eq.${playerId}`, }, handlePlayerHandsTableChanges)
            .subscribe();
    }

    const subscribeRoundsChannel = () => {
        supabase
            .channel('roundChannel')
            .on('postgres_changes', { event: '*', schema: 'public', table: 'Rounds', filter: `game=eq.${gameId}`, }, handleRoundsTableChanges)
            .subscribe();
    }

    const subscribeRoundBlackCardsChannel = () => {
        supabase
            .channel('roundBlackCardsChannel')
            .on('postgres_changes', { event: '*', schema: 'public', table: 'RoundBlackCards', filter: `game=eq.${gameId}`, }, handleRoundBlackCardsTableChanges)
            .subscribe();
    }

    const subscribeScoresChannel = () => {
        supabase
            .channel('scoresChannel')
            .on('postgres_changes', { event: '*', schema: 'public', table: 'Scores', filter: `game=eq.${gameId}`, }, handleScoresTableChanges)
            .subscribe();
    }

    const subscribeBackgroundsChannel = () => {
        supabase
            .channel('backgroundsChannel')
            .on('postgres_changes', { event: '*', schema: 'public', table: 'Backgrounds', filter: `game=eq.${gameId}`, }, handleBackgroundsTableChanges)
            .subscribe();
    }

    useEffect(() => {
        playersRef.current = [...players];
    }, [players])

    useEffect(() => {
        roundBlackCardsRef.current = [...roundBlackCards];
    }, [roundBlackCards])

    useEffect(() => {
        lastOpenRoundBlackCardIdxRef.current = lastOpenRoundBlackCardIdx;
    }, [lastOpenRoundBlackCardIdx])

    useEffect(() => {
        keyMomentsRef.current = [...keyMoments];
    }, [keyMoments])

    useEffect(() => {
        scoresMapRef.current = new Map(scoresMap);
    }, [scoresMap])

    useEffect(() => {
        currentPlayerRef.current = currentPlayer.clone();
    }, [currentPlayer])

    useEffect(() => {
        criminalRef.current = criminal.clone();
    }, [criminal])

    useEffect(() => {
        judgeRef.current = judge.clone();
    }, [judge])

    useEffect(() => {
        roundWinnerRef.current = roundWinner.clone();
    }, [roundWinner])

    useEffect(() => {
        currentRoundRef.current = {...currentRound};
    }, [currentRound])

    useEffect(() => {
        hostIsInBackgroundRef.current = hostIsInBackground;
    }, [hostIsInBackground])

    useEffect(() => {
        usedBlackCardsIndicesRef.current = [...usedBlackCardsIndices];
    }, [usedBlackCardsIndices])

    useEffect(() => {
        roundPhaseRef.current = roundPhase;
    }, [roundPhase])

    useEffect(() => {
        winningBlackCardIdxRef.current = winningBlackCardIdx;
    }, [winningBlackCardIdx])

    useEffect(() => {
        PageView.addNewPageView(Pages.GameRoom);
    }, [])

    useEffect(() => {
        document.addEventListener("visibilitychange", handleVisibilityChange);
        if (isLate) {
            refresh();
            subscribeGamesChannel();
            subscribePlayersChannel();
            subscribeHandChannel();
            subscribeRoundsChannel();
            subscribeRoundBlackCardsChannel();
            subscribeScoresChannel();
            subscribeBackgroundsChannel();
        }
        getPlayers().then(() => {
            subscribeGamesChannel();
            subscribePlayersChannel();
            subscribeHandChannel();
            subscribeRoundsChannel();
            subscribeRoundBlackCardsChannel();
            subscribeScoresChannel();

            if (isHost) {
                subscribeHandsChannel();
                drawBlackCards();
                play();
            } else {
                subscribeBackgroundsChannel();
            }
        });

        return () => {
            clearInterval(roundTimerRef.current);
            roundTimerRef.current = null;
            clearInterval(roundWinnerPageTimerRef.current);
            roundWinnerPageTimerRef.current = null;
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            supabase.removeAllChannels();
        }
    }, [])

    return (
        <div className="overallWrapper">
            <HeaderInGame/>
            <div className="gameRoomWrapper">
                <div className="gameRoomTop">
                    {roundPhaseRef.current !== RoundPhase.roundWinner && <GameHeader players={playersRef.current} isHost={isHost} roundPhase={roundPhaseRef.current} popup={popup} openEndExitGameDialog={openEndExitGameDialog} openRulesDialog={openRulesDialog} refresh={handleRefresh} openRemovePlayerDialog={openRemovePlayerDialog}/>}
                </div>
                <div className="gameRoomMiddle">
                    {playersRef.current.length === 1 && <GameRoomOnePlayer players={playersRef.current} currentRound={currentRoundRef.current} roundBlackCards={roundBlackCardsRef.current} roundPhase={roundPhaseRef.current} scoresMap={scoresMap} shouldShowHand={shouldShowHand} />}
                    {playersRef.current.length === 2 && <GameRoomTwoPlayers players={playersRef.current} currentRound={currentRoundRef.current} roundBlackCards={roundBlackCardsRef.current} roundPhase={roundPhaseRef.current} scoresMap={scoresMap} shouldShowHand={shouldShowHand} />}
                    {playersRef.current.length === 3 && <GameRoomThreePlayers players={playersRef.current} currentRound={currentRoundRef.current} roundBlackCards={roundBlackCardsRef.current} roundPhase={roundPhaseRef.current} scoresMap={scoresMap} shouldShowHand={shouldShowHand} />}
                    {playersRef.current.length === 4 && <GameRoomFourPlayers players={playersRef.current} currentRound={currentRoundRef.current} roundBlackCards={roundBlackCardsRef.current} roundPhase={roundPhaseRef.current} scoresMap={scoresMap} shouldShowHand={shouldShowHand} />}
                    {playersRef.current.length === 5 && <GameRoomFivePlayers players={playersRef.current} currentRound={currentRoundRef.current} roundBlackCards={roundBlackCardsRef.current} roundPhase={roundPhaseRef.current} scoresMap={scoresMap} shouldShowHand={shouldShowHand} />}
                    {playersRef.current.length === 6 && <GameRoomSixPlayers players={playersRef.current} currentRound={currentRoundRef.current} roundBlackCards={roundBlackCardsRef.current} roundPhase={roundPhaseRef.current} scoresMap={scoresMap} shouldShowHand={shouldShowHand} />}
                    {playersRef.current.length === 7 && <GameRoomSevenPlayers players={playersRef.current} currentRound={currentRoundRef.current} roundBlackCards={roundBlackCardsRef.current} roundPhase={roundPhaseRef.current} scoresMap={scoresMap} shouldShowHand={shouldShowHand} />}
                    {playersRef.current.length === 8 && <GameRoomEightPlayers players={playersRef.current} currentRound={currentRoundRef.current} roundBlackCards={roundBlackCardsRef.current} roundPhase={roundPhaseRef.current} scoresMap={scoresMap} shouldShowHand={shouldShowHand} />}
                </div>
                <div className="gameRoomDeckAndTimerWrapper">
                    <img className="gameRoomDeck" src={deck} alt="deck"/>
                    {roundPhaseRef.current === RoundPhase.waitForOthersToPlay && <div className="gameRoomTimer">{getTimerText(roundTimeInSecondsRef.current)}</div>}
                </div>
                {roundPhaseRef.current === RoundPhase.openRedCard && <OpenRedCardDialog gameId={gameId} playerId={playerId} statsId={statsId} currentRound={currentRoundRef.current} judge={judgeRef.current} criminal={criminalRef.current} skipped={skipped} popup={popup} />}
                {roundPhaseRef.current === RoundPhase.playBlackCard && <PlayBlackCardsDialog statsId={statsId} currentPlayer={currentPlayerRef.current} setCurrentPlayer={setCurrentPlayer} currentRound={currentRoundRef.current} judge={judgeRef.current} criminal={criminalRef.current} timeInSeconds={roundTimeInSecondsRef.current} popup={popup} getBlackCardSubmitTime={getBlackCardSubmitTime} />}
                {roundPhaseRef.current === RoundPhase.lookAtPlayedCards && <SelectBlackCardDialog gameId={gameId} statsId={statsId} playerId={playerId} currentRound={currentRoundRef.current} roundBlackCards={roundBlackCardsRef.current} judge={judgeRef.current} criminal={criminalRef.current} scoresMap={scoresMap} lastOpenRoundBlackCardIdx={lastOpenRoundBlackCardIdxRef.current} popup={popup} handleCloseOpenedBlackCard={handleCloseOpenedBlackCard} />}
                {roundPhaseRef.current === RoundPhase.roundWinner && <RoundWinnerDialog currentRound={currentRoundRef.current} criminal={criminalRef.current} winningBlackCardIdx={winningBlackCardIdxRef.current} roundWinnerName={roundWinnerRef.current.name} timeInSeconds={roundWinnerPageTimeLeftInSecondsRef.current} />}
                {popup === Popups.endExitGame && <EndExitGameDialog gameId={gameId} playerId={playerId} isHost={isHost} statsId={statsId} closeDialog={closeDialog}/>}
                {popup === Popups.removePlayer && <RemovePlayerDialog players={playersRef.current} playerId={playerId} closeDialog={closeDialog} handleRemovePlayer={handleRemovePlayer}/>}
                {popup === Popups.rules && <RulesDialog closeDialog={closeDialog}/>}
                {popup === Popups.judgeRules && <JudgeRulesDialog closeDialog={closeDialog}/>}
                {popup === Popups.endExitGameNotification && <EndExitGameNotificationDialog title={endExitGameNotificationTitle} subtitle={endExitGameNotificationSubtitle} closeDialog={closeDialog}/>}
                {popup === Popups.waitingForHost && <WaitingForHostDialog/>}
                {isDeletingGame && <LoadingComponent/>}
            </div>
        </div>
    );
};

export default GameRoomDialog;